module.exports = __webpack_public_path__ + "static/media/berries-sauce.66840e80.png";